module.exports = __webpack_public_path__ + "static/media/480.d5a91e2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-slug-eating/light/480.png
// module id = 2434
// module chunks = 2